import { Box, Button, ButtonGroup, IconButton, Typography } from '@mui/material'
import React from 'react'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { getNiceTimestamp } from 'src/utils/get-nice-timestamp';

const CalendarGridControl = ({calendarSettings, setCalendarSettings}) => {
    const { t } = useTranslation()

    const handleSwitchToMonth = () => {
        const newStartDate = new Date(calendarSettings.startDate.getFullYear(), calendarSettings.startDate.getMonth(), 1)
        const daysInMonth = new Date(newStartDate.getFullYear(), newStartDate.getMonth()+1, 0)
        // let newEndDate = new Date(calendarSettings.startDate.getFullYear(), calendarSettings.startDate.getMonth(), daysInMonth-1)
        // newEndDate.setDate(newEndDate.getDate() + daysInMonth)

        setCalendarSettings({
            startDate: newStartDate,
            endDate: daysInMonth
        })
    }

    const handleSwitchToWeek = () => {
        const startD = new Date(calendarSettings.startDate)
        const endD = new Date(calendarSettings.startDate)
        startD.setDate(startD.getDate() - startD.getDay())
        endD.setDate(endD.getDate() + (6 - endD.getDay()))

        setCalendarSettings({
            startDate: startD,
            endDate: endD
        })
    }

    const handleSwitchToDay = () => {
        // const endD = calendarSettings.startDate
        // endD.setDate(endD.getDate() + 1)
        setCalendarSettings({
            startDate: calendarSettings.startDate,
            endDate: calendarSettings.startDate
        })
    }

    const handleMoveCalendar = (direction) => {
        const daysDiff = Math.floor((calendarSettings.endDate - calendarSettings.startDate) / (1000 * 60 * 60 * 24))
        let startDate = new Date(calendarSettings.startDate)
        let endDate = new Date(calendarSettings.endDate)
        if(direction == 'right') {
            if(daysDiff == 0) {
                startDate.setDate(startDate.getDate() + 1)
                endDate.setDate(endDate.getDate() + 1)
                setCalendarSettings({
                    startDate: startDate,
                    endDate:  endDate
                })
            }else if(daysDiff == 6){
                startDate.setDate(startDate.getDate() + 7)
                endDate.setDate(endDate.getDate() + 7)
                setCalendarSettings({
                    startDate: startDate,
                    endDate:  endDate
                })
            }else{
                

                const newStartDate = new Date(endDate)
                newStartDate.setDate(newStartDate.getDate() + 1)
                const newEndDate = new Date(newStartDate.getFullYear(), newStartDate.getMonth()+1, 0)

                // const monthFirstDate = newEndDate
                // const daysInMonth = new Date(monthFirstDate.getFullYear(), monthFirstDate.getMonth(), 0).getDate()
                // console.log(monthFirstDate)
                // const startDateNew = new Date(monthFirstDate.getFullYear(), monthFirstDate.getMonth(), daysInMonth)
                // console.log(startDateNew)

                // const newStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1)
                // const newEndDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1)
                // const daysInMonth = new Date(newStartDate.getFullYear(), newStartDate.getMonth(), 0).getDate()

                // newEndDate.setDate(newEndDate.getDate() + daysInMonth+1)

                setCalendarSettings({
                    startDate: newStartDate,
                    endDate: newEndDate
                })
            }
        }else{
            if(daysDiff == 0) {
                startDate.setDate(startDate.getDate() - 1)
                endDate.setDate(endDate.getDate() - 1)
                setCalendarSettings({
                    startDate: startDate,
                    endDate:  endDate
                })
            }else if(daysDiff == 6){
                startDate.setDate(startDate.getDate() - 7)
                endDate.setDate(endDate.getDate() - 7)
                setCalendarSettings({
                    startDate: startDate,
                    endDate:  endDate
                })
            }else{
                const previousMonth = new Date(calendarSettings.startDate.getFullYear(), calendarSettings.startDate.getMonth(), 1)
                previousMonth.setDate(previousMonth.getDate() - 1)
                const startDate = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), 1)

                // const daysInMonth = new Date(calendarSettings.startDate.getFullYear(), calendarSettings.startDate.getMonth(), 0).getDate()
                // endDate.setDate(endDate.getDate() - daysInMonth+1)
                // const daysInPreviousMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate()
                // startDate.setDate(startDate.getDate() - daysInPreviousMonth+1)
                setCalendarSettings({
                    startDate: startDate,
                    endDate:  previousMonth
                })
            }
        }
    }

    const handleSetToday = () => {
        const daysDiff = Math.floor((calendarSettings.endDate - calendarSettings.startDate) / (1000 * 60 * 60 * 24))
        if(daysDiff == 0){
            // const endDate = new Date()
            // endDate.setDate(endDate.getDate() + 1)
            setCalendarSettings({
                startDate: new Date(),
                endDate: new Date()
            })
        }else if(daysDiff == 6) {
            const startDate = new Date()
            const endDate = new Date()
            startDate.setDate(startDate.getDate() - startDate.getDay())
            endDate.setDate(endDate.getDate() + (6 - endDate.getDay()))

            setCalendarSettings({
                startDate: startDate,
                endDate: endDate
            })
        }else{
            const date = new Date()
            const startDate = new Date(date.getFullYear(), date.getMonth(), 1)
            const endDate = new Date(date.getFullYear(), date.getMonth(), 1)
            const daysInMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 0).getDate()

            endDate.setDate(startDate.getDate() + daysInMonth)

            setCalendarSettings({
                startDate: startDate,
                endDate: endDate
            })
        }
    }

    return (
        <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
            flexWrap: "wrap",
            gap: 2
        }}>
            <Box>
                <IconButton onClick={() => handleMoveCalendar('left')}>
                    <ArrowBackIosNewIcon fontSize='small'/>
                </IconButton>
                <IconButton onClick={() => handleMoveCalendar('right')}>
                    <ArrowForwardIosIcon fontSize='small'/>
                </IconButton>
                <Button size="sm" onClick={handleSetToday}>{
                    Math.floor((calendarSettings?.endDate - calendarSettings?.startDate) / (1000 * 60 * 60 * 24)) == 0 ? t("views.scheduler.today") :
                    Math.floor((calendarSettings?.endDate - calendarSettings?.startDate) / (1000 * 60 * 60 * 24)) == 6 ? t("views.scheduler.thisWeek") : 
                    t("views.scheduler.thisMonth")
                }</Button>
            </Box>
            <Typography variant='h6'>{getNiceTimestamp(calendarSettings?.startDate)} {Math.floor((calendarSettings?.endDate - calendarSettings?.startDate) / (1000 * 60 * 60 * 24)) !== 0 && (
    <>
        <ArrowRightAltIcon fontSize="small" sx={{
            position: "relative",
            top: "4px",
            margin: "0 10px"
        }} />
        {getNiceTimestamp(calendarSettings?.endDate)}
    </>
)}</Typography>
            <Box>
                <ButtonGroup size="sm">
                    <Button onClick={handleSwitchToMonth}>{t("views.scheduler.month")}</Button>
                    <Button onClick={handleSwitchToWeek}>{t("views.scheduler.week")}</Button>
                    <Button onClick={handleSwitchToDay}>{t("views.scheduler.day")}</Button>
                </ButtonGroup>
            </Box>
        </Box>
  )
}

export default CalendarGridControl
